/* Fairy Glow Puff — bundle maison (Dravella). 1 pot, ou 2 + 1 offert : on choisit le POT (la teinte) de chaque unité.
   Le panier reçoit N lignes réelles ; le 3e pot est offert par une remise automatique Shopify (montant fixe, ≥ 3 pots).
   Ajout au panier : même mécanique que l'Anillo Elora (sections dans /cart/add.js puis renderContents du tiroir Revive). */
(() => {
  document.querySelectorAll("[data-fgp]").forEach((root) => {
    const cfg = JSON.parse(root.querySelector("[data-config]").textContent);
    const t = cfg.strings;
    const offers = [...root.querySelectorAll(".svb__offer")];
    const form = root.querySelector("[data-bundle-form]");
    const submit = root.querySelector("[data-submit]");
    const error = root.querySelector("[data-error]");
    let quantity = Number(root.dataset.quantity) || 3;
    let busy = false;

    /* Hors devise de base, Shopify arrondit le prix converti mais PAS la remise convertie :
       le prix du lot doit se calculer comme le panier → 3 × prix affiché − remise × taux. */
    const fmt = (cents) => {
      const f = cfg.moneyFormat || "${{amount}}";
      const n = (cents / 100).toFixed(2);
      const sep = (s, t, d) => s.replace(/\B(?=(\d{3})+(?!\d))/g, t) ;
      const [i, d] = n.split(".");
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) =>
        k === "amount_with_comma_separator" ? sep(i, ".") + "," + d :
        k === "amount_no_decimals" ? sep(i, ",") :
        k === "amount_no_decimals_with_comma_separator" ? sep(i, ".") : sep(i, ",") + "." + d);
    };
    const taux = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    cfg.price3 = cfg.price3fix != null ? cfg.price3fix : 3 * cfg.price1 - Math.round(cfg.remise3 * taux);  /* 16/10 : prix du lot fixé par devise (produit offre) */
    const p3el = root.querySelector("[data-p3]");
    /* barré du lot : 3 × barré du pot, arrondi au ,90 supérieur (104.70 → 104.90) pour ressembler à un prix */
    const c3 = Math.ceil((3 * cfg.cmp1 - 90) / 100) * 100 + 90;
    if (p3el && cfg.cmp1) p3el.innerHTML = `<s>${fmt(c3)}</s>${fmt(cfg.price3)}`;
    const ppel = root.querySelector("[data-pp]");
    if (ppel) ppel.textContent = fmt(Math.round(cfg.price3 / 3));

    const money = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || "en", {
          style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD"
        }).format(cents / 100);
      } catch (e) { return "$" + (cents / 100).toFixed(2); }
    };

    /* une teinte en rupture choisie dans l'offre active = bouton « Sold out » */
    const soldOut = () => {
      const offer = offers.find((o) => o.classList.contains("is-on")) || offers.find((o) => Number(o.querySelector(".svb__choice").dataset.quantity) === quantity);
      return !!offer && !!offer.querySelector('[data-variant][aria-pressed="true"][data-soldout]');
    };

    const sync = () => {
      offers.forEach((o) => {
        const on = Number(o.querySelector(".svb__choice").dataset.quantity) === quantity;
        o.classList.toggle("is-on", on);
        o.querySelector(".svb__choice").setAttribute("aria-pressed", String(on));
      });
      const total = quantity === 1 ? cfg.price1 : cfg.price3;
      const rupture = soldOut();
      submit.textContent = busy ? t.busy : rupture ? (t.soldout || "Sold out") : `${t.add} · ${fmt(total)}`;
      submit.disabled = busy || rupture;
      submit.classList.toggle("is-soldout", rupture);
    };

    offers.forEach((o) => {
      o.querySelector(".svb__choice").addEventListener("click", () => {
        quantity = Number(o.querySelector(".svb__choice").dataset.quantity);
        error.hidden = true;
        sync();
      });
    });

    /* la 1re image de la galerie (et sa vignette) passe au rendu de la teinte sur le bras */
    const montrerBras = (shade) => {
      const url = cfg.bras && cfg.bras[shade];
      const g = document.querySelector("media-gallery");
      if (!url || !g) return;
      const li = g.querySelector('[id^="GalleryViewer"] li');
      const img = li && li.querySelector("img");
      if (img) { img.removeAttribute("srcset"); img.src = url; }
      const th = g.querySelector('[id^="GalleryThumbnails"] li img');
      if (th) { th.removeAttribute("srcset"); th.src = url; }
      try { if (li && li.dataset.mediaId && g.setActiveMedia) g.setActiveMedia(li.dataset.mediaId, false); } catch (e) {}
    };

    /* un clic sur un pot = la teinte de cette unité */
    root.querySelectorAll("[data-unit]").forEach((unit) => {
      const pots = [...unit.querySelectorAll("[data-variant]")];
      const label = unit.querySelector("[data-shade-label]");
      /* présélection : le n-ième pot EN STOCK (les pots en rupture sont rangés en dernier par le Liquid) */
      const libres = pots.filter((x) => !x.hasAttribute("data-soldout"));
      const d0 = libres.length ? libres[(Number(unit.dataset.default || 1) - 1) % libres.length] : pots[0];
      if (d0) { d0.setAttribute("aria-pressed", "true"); if (label) label.textContent = d0.dataset.shade; }
      pots.forEach((p) => p.addEventListener("click", () => {
        pots.forEach((x) => x.setAttribute("aria-pressed", String(x === p)));
        if (label) label.textContent = p.dataset.shade + (p.hasAttribute("data-soldout") ? " · " + (t.soldout || "Sold out") : "");
        montrerBras(p.dataset.shade);
        sync();
      }));
    });

    const units = () => {
      const offer = offers.find((o) => o.classList.contains("is-on"));
      return [...offer.querySelectorAll("[data-unit]")];
    };

    const refreshDrawer = async (data) => {
      const drawer = document.querySelector("cart-drawer");
      if (!drawer || typeof drawer.renderContents !== "function") {
        window.location.href = (window.routes && window.routes.cart_url) || "/cart";
        return;
      }
      const ids = drawer.getSectionsToRender().map((s) => s.id);
      if (!data.sections || ids.some((id) => !data.sections[id])) {
        const r = await fetch(`${window.location.pathname}?sections=${ids.join(",")}`);
        data = { sections: await r.json() };
      }
      drawer.classList.remove("is-empty");
      drawer.renderContents(data);
      drawer.open();
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        const cart = await fetch(((window.routes && window.routes.cart_url) || "/cart") + ".js").then((r) => r.json());
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "fairy-glow-puff-bundle", cartData: cart });
      }
    };

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (busy || soldOut()) return;
      error.hidden = true;
      /* 16/10 (règle Lucas) : UNE LIGNE PAR POT, même teinte répétée ; le lot 2+1 passe par le produit « offre »
         (prix fixe par devise) et la remise BXGY met le 3e pot à 0 $ */
      const items = units().map((u, n) => {
        const p = u.querySelector('[data-variant][aria-pressed="true"]');
        const id = (quantity === 3 && cfg.offre && cfg.offre[p.dataset.shade]) || Number(p.dataset.variant);
        return { id, quantity: 1, properties: { _l: String(n + 1) } };
      });
      busy = true;
      sync();
      try {
        const drawer = document.querySelector("cart-drawer");
        const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
        const response = await fetch(((window.routes && window.routes.cart_add_url) || "/cart/add") + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items.slice().reverse(), sections, sections_url: window.location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || t.error);
        await refreshDrawer(data);
      } catch (e) {
        error.textContent = e.message || t.error;
        error.hidden = false;
      } finally {
        busy = false;
        sync();
      }
    });

    sync();
  });
})();
